import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=22d4731f&scoped=true"
import script from "./ServiceView.vue?vue&type=script&lang=js"
export * from "./ServiceView.vue?vue&type=script&lang=js"
import style0 from "./ServiceView.vue?vue&type=style&index=0&id=22d4731f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d4731f",
  null
  
)

export default component.exports